import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, signal, ViewChild, ElementRef } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { PermissaoAcessoService } from '../../services/permissao-acesso.service';

interface RelatorioItem {
    id: string;
    nome: string;
    descricao: string;
}

interface VendedorOpcao {
    codVend: string | number;
    apelido: string;
}

// @ts-ignore
@Component({
    selector: 'app-gpl-relatorios-comissoes',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
    templateUrl: './gpl-relatorios-comissoes.component.html',
    styleUrl: './gpl-relatorios-comissoes.component.css'
})
export class GplRelatoriosComissoesComponent implements OnInit {
    carregando = signal(false);
    modalRelatoriosAberto = false;
    totalFaturamentoAnalitico: number = 0;
    @ViewChild('inputFiltroNome') inputFiltroNome!: ElementRef;

    // Lista fixa de relatórios disponíveis
    listaRelatorios: RelatorioItem[] = [
        { id: 'comissoes', nome: 'Relatório de Comissões por Vendedor', descricao: 'Demonstrativo de comissões de vendedores por período.' }
    ];

    relatorioSelecionado: RelatorioItem | null = null;

    // Filtros Gerais baseados no pedido-venda
    filtros = {
        dataInicial: this.formatarDataInput(this.diasAntes(new Date(), 30)),
        dataFinal: this.formatarDataInput(new Date()),
        tipoFiltro: 'VENDIDO'
    };

    // Controle do Modal de Busca de Vendedor (Padrão Pedido de Venda)
    codVendSelecionado: string | number | null = null;
    vendedores: VendedorOpcao[] = [];
    vendedorModalAberta = false;
    filtroVendedor = '';

    // Dados retornados da busca
    dadosResultado: any[] = [];
    buscaMensagem = 'Selecione um relatório e aplique os filtros para buscar.';

    listaComissaoPorVendedor: any[] = [];
    valorComissaoFormatado: string = 'R$ 0,00';

    modoAgrupado = true;
    demonstrativoTipoAnalitico: 'VENDA' | 'ITEM' = 'VENDA';
    dadosAnaliticos: any[] = [];
    dadosAnaliticosAgrupados: any[] = [];
    dadosAnaliticosOriginal: any[] = [];
    carregandoAnalitico: boolean = false;
    mensagemAnalitico: string = '';
    alvoImpressao: 'SINTETICO' | 'ANALITICO' | null = null;

    podeVerTodosVendedores = false;

    constructor(
        private readonly sankhyaGateway: SankhyaGatewayService,
        readonly empresaState: EmpresaStateService,
        private readonly permissaoAcesso: PermissaoAcessoService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.carregando.set(true);
        try {
            // 1. Aguarda a resposta real da permissão antes de continuar
            this.podeVerTodosVendedores = await this.permissaoAcesso.podeVerTodosVendedoresComissoes();
            this.modalRelatoriosAberto = false;
            this.relatorioSelecionado = this.listaRelatorios[0];
            this.empresaState.carregar();
            await this._carregarVendedores();
        } catch (err) {
            console.error('Erro ao validar permissões de acesso:', err);
            this.podeVerTodosVendedores = false; // Fallback seguro em caso de falha externa
        } finally {
            this.carregando.set(false);
        }
    }

    imprimirAnalitico(): void {
        this.alvoImpressao = 'ANALITICO';

        // 1. Cria uma tag de estilo dinamicamente
        const style = document.createElement('style');
        style.id = 'forcar-paisagem';
        style.innerHTML = `@media print { @page { size: landscape !important; } }`;
        document.head.appendChild(style);

        setTimeout(() => {
            // 2. Abre a tela de impressão (o navegador pausa a tela aqui)
            window.print();
            
            // 3. Quando o usuário fecha a janela de impressão, o código volta a rodar
            this.alvoImpressao = null;
            
            // 4. Remove a tag para que a próxima impressão não saia deitada
            const styleRemover = document.getElementById('forcar-paisagem');
            if (styleRemover) {
                styleRemover.remove();
            }
        }, 100);
    }

    imprimirSintetico(): void {
        this.alvoImpressao = 'SINTETICO';

        // Dá 100ms para o Angular aplicar a classe CSS de esconder na tela
        setTimeout(() => {
            window.print();
            this.alvoImpressao = null; // Reseta a tela imediatamente após abrir a impressora
        }, 100);
    }

    get vendedoresFiltrados(): VendedorOpcao[] {
        const filtro = this.filtroVendedor.trim().toUpperCase();
        if (!filtro) return this.vendedores;
        return this.vendedores.filter(v => (v.apelido || '').toUpperCase().includes(filtro));
    }

    descricaoVendedor(codigo: string | number | null): string {
        const codigoAtual = String(codigo ?? '').trim();
        const opcao = this.vendedores.find(v => String(v.codVend) === codigoAtual);
        return opcao ? opcao.apelido : '';
    }

    valorExibidoVendedor(codigo: string | number | null): string {
        const codigoAtual = String(codigo ?? '').trim();
        const descricao = this.descricaoVendedor(codigoAtual);
        return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
    }

    onInputVendedor(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;
        const cursorPos = input.selectionStart ?? valorDigitado.length;

        const idx = valorDigitado.indexOf(' - ');
        const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

        this.codVendSelecionado = novoCodigo;

        const novoValor = this.valorExibidoVendedor(novoCodigo);
        setTimeout(() => {
            input.value = novoValor;
            const novaPos = Math.min(cursorPos, novoCodigo.length);
            input.setSelectionRange(novaPos, novaPos);
        });
    }

    private async _carregarVendedores(): Promise<void> {
        try {
            let res: any;
            if (this.podeVerTodosVendedores) {
                res = await firstValueFrom(this.sankhyaGateway.buscarVendedoresPedidoVenda());
            } else {
                res = await firstValueFrom(this.sankhyaGateway.buscarVendedoresPedidoVenda({ apenasProprio: true }));
            }

            const body = res?.responseBody ?? res;
            const retornoVendedores = body?.vendedores;

            // Normaliza para garantir que this.vendedores seja SEMPRE um array
            if (!retornoVendedores) {
                this.vendedores = [];
            } else if (Array.isArray(retornoVendedores)) {
                this.vendedores = retornoVendedores; // Já é um array (veio mais de um)
            } else {
                this.vendedores = [retornoVendedores]; // Veio apenas um objeto, envelopamos em um array
            }

            if (this.vendedores.length === 1) {
                this.selecionarVendedor(this.vendedores[0]);
            }
        } catch (err) {
            console.error('Erro ao carregar lista de vendedores:', err);
        }
    }

    abrirBuscaVendedor(): void {
        this.filtroVendedor = '';
        this.vendedorModalAberta = true;

        setTimeout(() => {
            if (this.inputFiltroNome) {
                this.inputFiltroNome.nativeElement.focus();
            }
        }, 100);
    }

    fecharBuscaVendedor(): void {
        this.vendedorModalAberta = false;
    }

    selecionarVendedor(v: VendedorOpcao): void {
        this.codVendSelecionado = v.codVend;
        this.vendedorModalAberta = false;
    }

    limparVendedor(): void {
        if (this.vendedores.length === 1) {
            return; 
        }

        this.codVendSelecionado = null;
    }

    selecionarRelatorio(relatorio: RelatorioItem): void {
        this.relatorioSelecionado = relatorio;
        this.modalRelatoriosAberto = false;
        this.dadosResultado = [];
        this.buscaMensagem = 'Preencha os filtros e clique em Buscar.';
        this.limparVendedor();
        this.filtros.tipoFiltro = 'VENDIDO';
    }

    async buscarDadosRelatorioComissaoVendedor(): Promise<void> {
        if (!this.relatorioSelecionado) return;

        if (!this.filtros.dataInicial || !this.filtros.dataFinal) {
            this.buscaMensagem = 'As datas Inicial e Final são obrigatórias para realizar a consulta.';
            return; // Barra a execução aqui
        }

        this.dadosAnaliticos = [];

        // 2. VALIDAÇÃO DE PERÍODO (Máximo 31 dias)
        // Como já validamos acima que elas existem, podemos usar direto aqui
        const dataIni = new Date(this.filtros.dataInicial + 'T00:00:00');
        const dataFim = new Date(this.filtros.dataFinal + 'T00:00:00');

        // Verifica se a data final é menor que a inicial
        if (dataFim.getTime() < dataIni.getTime()) {
            this.buscaMensagem = 'A data final não pode ser menor que a data inicial.';
            return; // Interrompe a execução
        }

        const diferencaEmMilissegundos = dataFim.getTime() - dataIni.getTime();
        const diferencaEmDias = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

        if (diferencaEmDias > 31) {
            this.buscaMensagem = 'O período consultado não pode ultrapassar 31 dias.';
            return; // Barra a consulta e não chama o Backend
        }

        this.carregando.set(true);
        this.dadosResultado = [];
        this.buscaMensagem = 'Buscando informações...';

        try {
            if (this.relatorioSelecionado.id === 'comissoes') {
                const response: any = await firstValueFrom(this.sankhyaGateway.consultarComissoesVendedores(this.montarPayloadFiltros()));

                const resBody = response?.responseBody ?? response;

                if (resBody.sucesso) {
                    const respostaBackend = resBody.listaComissaoPorVendedor;

                    //Se for lista, retorna ele, se for objeto único, transforma em array, se for nulo, retorna array vazio
                    const listaComissoes = Array.isArray(respostaBackend) ? 
                                                respostaBackend : 
                                                (respostaBackend ? //ta tratando assim para se vier um objeto único, ele transforma em array
                                                    [respostaBackend] : []);

                    this.listaComissaoPorVendedor = listaComissoes;
                    this.valorComissaoFormatado = resBody.valorComissao || 'R$ 0,00';

                    if (resBody.valorComissao) {
                        this.valorComissaoFormatado = resBody.valorComissao;
                    } else {
                        const totalNum = listaComissoes.reduce((acc: number, curr: any) => acc + (curr.VALORCOMISSAO || curr.valorComissao || 0), 0);
                        this.valorComissaoFormatado = this.formatarMoeda(totalNum);
                    }

                    if (this.listaComissaoPorVendedor.length === 0) {
                        this.buscaMensagem = 'Nenhum valor de comissão encontrado para este período.';
                    } else {
                        this.buscaMensagem = '';
                    }

                    this.listaComissaoPorVendedor.forEach((vend, index) => {
                        vend.comissoes.forEach((f: any) => {
                            if (f.tipoParametro === 'FIXA') {
                                f.textoComposicao =
                                    `Parâmetro ${f.codRegraParam} (${f.tipoParametro})` +
                                    ` - Valor Fixo: ${this.formatarMoeda(f.valorComissaoBase)} por unidade.`;
                            } else {
                                if (f.tipoParametro === 'PORCENTAGEM') {
                                    if (f.valorRefFinal && f.valorRefFinal > 0) {
                                        f.textoComposicao =
                                            `Parâmetro ${f.codRegraParam} (${f.tipoParametro})` +
                                            ` de ${f.valorRefInicial}${f.unidadeReferencia} até ${f.valorRefFinal}${f.unidadeReferencia}` +
                                            ` à ${f.valorComissaoBase}${f.unidadeComissao}` +
                                            `\nBase calculo: ${this.formatarMoeda(f.baseCalculo)}`;
                                    } else {
                                        f.textoComposicao =
                                            `Parâmetro ${f.codRegraParam} (${f.tipoParametro})` +
                                            ` acima de ${f.valorRefInicial}${f.unidadeReferencia}` +
                                            ` à ${f.valorComissaoBase}${f.unidadeComissao}` +
                                            `\nBase calculo: ${this.formatarMoeda(f.baseCalculo)}`;
                                    }
                                } else {
                                    if (f.valorRefFinal && f.valorRefFinal > 0) {
                                        f.textoComposicao =
                                            `Parâmetro ${f.codRegraParam} (${f.tipoParametro})` +
                                            ` de ${this.formatarMoeda(f.valorRefInicial)} até ${this.formatarMoeda(f.valorRefFinal)}` +
                                            ` à ${f.valorComissaoBase}${f.unidadeComissao}` +
                                            `\nBase calculo: ${this.formatarMoeda(f.baseCalculo)}`;
                                    } else {
                                        f.textoComposicao =
                                            `Parâmetro ${f.codRegraParam} (${f.tipoParametro})` +
                                            ` acima de ${this.formatarMoeda(f.valorRefInicial)}` +
                                            ` à ${f.valorComissaoBase}${f.unidadeComissao}` +
                                            `\nBase calculo: ${this.formatarMoeda(f.baseCalculo)}`;
                                    }
                                }
                            }
                        });
                    });
                } else {
                    this.buscaMensagem = resBody.erro || 'Erro ao carregar o resumo de comissões.';
                }
            }
        } catch (e) {
            this.buscaMensagem = 'Erro de comunicação com o servidor.';
        } finally {
            this.carregando.set(false);
        }
    }

    /**
     * Gatilho: Botão "Gerar Relatório Analítico" que fica abaixo do totalizador
     */
    async gerarRelatorioAnalitico(): Promise<void> {
        if (!this.codVendSelecionado) {
            this.mensagemAnalitico = 'A seleção de um vendedor específico é obrigatória para gerar o relatório analítico.';
            return;
        }
        
        this.carregandoAnalitico = true;
        this.mensagemAnalitico = '';
        this.dadosAnaliticos = []; // Limpa a tabela anterior, se houver

        const payload = this.montarPayloadFiltros();

        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.consultarComissoesAnaliticas(payload)
            );

            const resBody = response?.responseBody ?? response;

            if (resBody.sucesso && resBody.vendas) {
                this.dadosAnaliticosOriginal = resBody.vendas;
                if (this.dadosAnaliticosOriginal.length === 0) {
                    this.mensagemAnalitico = 'Nenhuma nota elegível encontrada no analítico.';
                }

                this.totalFaturamentoAnalitico = this.dadosAnaliticosOriginal.reduce((acumulador, item) => {
                    // Soma o valor do item atual ao acumulador. 
                    // O "|| 0" evita erros caso algum item venha com o valor nulo do banco.
                    return acumulador + (item.vlrTotItem || 0);
                }, 0);

                const agrupamento = this.dadosAnaliticosOriginal.reduce((acc, item) => {
                    const chave = item.nunota;

                    if (!acc[chave]) {
                        acc[chave] = {
                            nunota: item.nunota,
                            numnota: item.numnota,
                            dtneg: item.dtneg,
                            com: item.com,
                            prefixo: item.prefixo,
                            tipoPessoa: item.tipoPessoa,
                            nomeParceiro: item.nomeParceiro,
                            razaoSocial: item.razaoSocial,
                            // Inicia o somatório
                            valorTotalVenda: 0,
                            // FLAG ÚTIL: Ajuda o HTML a saber que essa linha é um agrupamento
                            isAgrupamento: true 
                        };
                    }

                    // Substitua 'valorItem' pela propriedade real do seu back-end
                    acc[chave].valorTotalVenda += Number(item.vlrTotItem || 0);

                    return acc;
                }, {});

                this.dadosAnaliticosAgrupados = Object.values(agrupamento);

                // =========================================================
                // 2. LÓGICA DE ORDENAÇÃO: 1º Data, 2º Número Único (nunota)
                // =========================================================
                const ordenarPorDataENunota = (a: any, b: any) => {
                    // Converte "DD/MM/YYYY" para "YYYYMMDD" (ex: 20260310)
                    const converterData = (dataStr: string) => {
                        if (!dataStr) return 0;
                        const partes = dataStr.split('/');
                        return Number(`${partes[2]}${partes[1]}${partes[0]}`);
                    };

                    // Critério 1: Compara as datas
                    const diferencaData = converterData(a.dtneg) - converterData(b.dtneg);

                    // Se as datas forem iguais (diferença == 0), aplica o Critério 2 (NUNOTA)
                    if (diferencaData === 0) {
                        return a.nunota - b.nunota; 
                    }

                    // Se as datas forem diferentes, retorna a ordenação da data mesmo
                    return diferencaData;
                };

                this.dadosAnaliticosAgrupados.sort(ordenarPorDataENunota);
                this.dadosAnaliticosOriginal.sort(ordenarPorDataENunota);

                this.modoAgrupado = true; // Inicialmente, o relatório analítico é exibido de forma agrupada
                this.dadosAnaliticos = Object.values(this.dadosAnaliticosAgrupados);
            } else {
                this.mensagemAnalitico = resBody.erro || 'Erro ao carregar analítico.';
            }

        } catch (e) {
            this.mensagemAnalitico = 'Erro de comunicação com o servidor (Analítico).';
        } finally {
            this.carregandoAnalitico = false;
        }
    }

    // ==========================================
    // A função que o botão Switch vai chamar:
    // ==========================================
    alternarDetalhamento(tipo: 'VENDA' | 'ITEM'): void {
        if (tipo === 'VENDA') {  
            this.modoAgrupado = true;
        } else {
            this.modoAgrupado = false;
        }
        this.demonstrativoTipoAnalitico = tipo;
        this.atualizarTela();
    };

    atualizarTela() {
        if (this.modoAgrupado) {
            this.dadosAnaliticos = this.dadosAnaliticosAgrupados;
        } else {
            this.dadosAnaliticos = this.dadosAnaliticosOriginal;
        }
    };

    // Função auxiliar para evitar duplicação de código
    private montarPayloadFiltros(): any {
        let codVendParam = Number(this.codVendSelecionado);
        return {
            codVend: codVendParam,
            dataIni: this.filtros.dataInicial,
            dataFim: this.filtros.dataFinal,
            tipoBase: this.filtros.tipoFiltro
        };
    }

    imprimir(): void {
        window.print();
    }

    private diasAntes(data: Date, dias: number): Date {
        const d = new Date(data);
        d.setDate(data.getDate() - dias);
        return d;
    }

    private formatarDataInput(data: Date): string {
        return data.toISOString().split('T')[0];
    }

    formatarPercentual(valor: number): string {
        if (valor == null || valor === 0) return '0,00%';
        
        const valorFormatado = new Intl.NumberFormat('pt-BR', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        }).format(valor);

        return `${valorFormatado}%`;
    }

    money(value: any): string {
        return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    formatarMoeda(valor: number): string {
        if (!valor) return '-';
        return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    obterNomeCliente(item: any): string {
        if (item?.tipoPessoa === 'J' && item?.razaoSocial) {
            return item.razaoSocial;
        }

        return item?.nomeParceiro || item?.nome || '';
    }

    get totalComissao(): number {
        return this.dadosResultado.reduce((acc, curr) => acc + Number(curr.VLRNOTA || curr.vlrnota || 0), 0);
    }

    /**
     * Adiciona automaticamente 30 dias à Data Final quando a Inicial é alterada
     */
    aoMudarDataInicial(novaDataIni: string): void {
        if (!novaDataIni) return;

        // Cria o objeto Date (O 'T00:00:00' evita problemas de fuso horário diminuindo 1 dia)
        const dataObj = new Date(novaDataIni + 'T00:00:00');

        // Adiciona 30 dias na data
        dataObj.setDate(dataObj.getDate() + 30);

        // Converte de volta para string no formato YYYY-MM-DD (padrão de inputs de data)
        const ano = dataObj.getFullYear();
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
        const dia = String(dataObj.getDate()).padStart(2, '0');

        this.filtros.dataFinal = `${ano}-${mes}-${dia}`;
    }
}